<template>
  <div class="flex flex-col flex-shrink-0 mx-4 py-8 text-center bg-white border-2 border-gray-200 rounded-lg dark:bg-gray-800 dark:border-gray-700 plan-C" style="height:385px; width:220px;">
    <div class="text-center">
        <h2 class="font-semibold text-yellow">
          {{ plansListCData.plan_c_title }}
        </h2>
        <!-- <span class="text-gray-500">適合企業</span> -->
    </div>
    <div class="text-gray-700 text-center font-mono flex flex-wrap justify-center content-center py-4 my-4 bg-plan-C">
      <div class="text-white">
        <p class="text-3xl">{{ plansListCData.plan_c_label_amount }}<span class="text-sm ml-2">/{{lang['components']['Plan']['PlanC']['time_unit']}}</span></p>
        <!--<p v-if="plansListCData.is_amount" class="text-sm">per month</p>-->
      </div>
    </div>
    <ul class="flex-1 space-y-2 text-gray-500 dark:text-gray-400 text-sm">
      <li v-for="(item, index) in description" class="border-b">
          <div v-html="item"></div>
      </li>
    </ul>
    <!--<button v-if="plansListCData.plan_c_show" class="rounded-full bg-plan-C mx-16 py-2 mt-12" :disabled="isDisabled" @click="handleChickPlan(plansListCData.plan_id, 'C')">
      {{ plansListCData.plan_c_text }}
    </button>-->
    <button
      v-if="!useFbCustomize"
      class="rounded-2xl bg-plan-C mx-16 p-2 mt-auto text-sm mb-2"
      @click="expCustomize"
    >
      流程體驗
    </button>
    <button v-if="plansListCData.plan_c_show" class="rounded-2xl bg-plan-C mx-16 p-2 mt-auto text-sm" @click="handleChickPlan(134, 'C', '', 'fb')">
      {{ plansListCData.plan_c_text }}
    </button>
    <button v-else-if="!plansListCData.planHaveBind" class="rounded-2xl bg-plan-C mx-16 p-2 mt-auto text-sm" @click="handleChickPlan(134, 'C', '', 'fb')">
      {{lang['components']['Plan']['PlanC']['pay_use']}}
    </button>
    <button
      v-else
      class="rounded-2xl bg-plan-C mx-16 p-2 mt-auto text-sm"
      v-if="isExpiredData && (plansListCData.plan_c_text == '使用中' || plansListCData.plan_c_text == 'Using')"
      @click="handleChickPlan(134, 'C', 'payAgain', 'fb')"
    >
      {{lang['components']['Plan']['PlanC']['plan_item_payagain_button_text']}}
    </button>
  </div>
</template>

<script>
export default {
  name: 'PlanC',
  props: {
    handleChickPlan: {
      type: Function,
      default: () => ({})
    },
    plansListC:{
      type:Object,
      required:true
    },
    isExpired: {
      type: Boolean
    },
    useFbCustomize: {
      type: Boolean
    },
    lang: {
      type: Object
    },
    expCustomize: {
      type: Function,
    }
  },
  data() {
    return {
      payError: true
    };
  },
  computed: {
    plansListCData: {
      get: function () {
        return this.plansListC
      },
      set: function (value) {
        this.$emit('update:plansListCData', value)
      },
    },
    isExpiredData: {
      get: function () {
        return this.isExpired
      },
      set: function (value) {
        this.$emit('update:isExpiredData', value)
      },
    },
    description: function() {
       return this.plansListC.plan_c_description
    },
    isDisabled: function() {
       return this.plansListC.plan_c_disable
    }
  }
}
</script>

<style lang="scss" scope>
  .plan-C {
    &:hover {
      border: 2px #F7D676 solid;
    }
  }
</style>